export default __webpack_public_path__ + "static/media/disGood.7882a973.svg";